module.exports = "/pages/business/foodslabo/support_image_2.png";